/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState } from 'react'
import { api } from '../api'
import '../css/home.css'
import Marquee from "react-fast-marquee";
import Divider from './Divider';
import titleBackground from '../imgs/building-4803602_1280.jpg'
import img1 from '../imgs/clients/1935826_977175972376437_4519537809033624598_n.png'
import img2 from '../imgs/clients/354008706_765490478605821_302093976834316275_n.jpg'
import img3 from '../imgs/clients/PHOTO-2023-08-26-17-47-24.jpg'
import img4 from '../imgs/clients/PHOTO-2023-08-26-17-47-56.jpg'
import img5 from '../imgs/clients/PHOTO-2023-08-26-17-50-48.jpg'
import img6 from '../imgs/clients/PHOTO-2023-08-26-17-52-04.jpg'
import img7 from '../imgs/clients/PHOTO-2023-08-26-17-53-02.jpg'
import img8 from '../imgs/clients/PHOTO-2023-08-26-17-58-46.jpg'
import img9 from '../imgs/clients/PHOTO-2023-08-30-16-49-23.jpg'
import img10 from '../imgs/clients/PHOTO-2023-08-30-16-49-24.jpg'
import img12 from '../imgs/clients/PHOTO-2023-08-30-16-49-25 1.jpg'
import img13 from '../imgs/clients/PHOTO-2023-08-30-16-49-25.jpg'
import img14 from '../imgs/clients/PHOTO-2023-08-30-16-49-27.jpg'
import img15 from '../imgs/clients/PHOTO-2023-08-30-16-49-28.jpg'
import img16 from '../imgs/clients/PHOTO-2023-08-30-16-49-29.jpg'
import img17 from '../imgs/clients/PHOTO-2023-08-30-16-49-30.jpg'
import img18 from '../imgs/clients/PHOTO-2023-08-30-16-49-31.jpg'
import img19 from '../imgs/clients/PHOTO-2023-08-30-16-49-32.jpg'
import img20 from '../imgs/clients/PHOTO-2023-08-30-16-49-33.jpg'
import img21 from '../imgs/clients/hawsaKids.jpg'
import img22 from '../imgs/clients/reemjolly.jpg'
import img23 from '../imgs/clients/sasheco_logo.jpeg'
import img24 from '../imgs/clients/track.jpg'
import img25 from '../imgs/serviceCards/financial-2860753_1280.jpg'
import img26 from '../imgs/serviceCards/gavel-3577254_1280.jpg'
import img27 from '../imgs/serviceCards/istockphoto-1154395726-612x612.jpg'
import img28 from '../imgs/serviceCards/istockphoto-1403453245-612x612.jpg'
import img29 from '../imgs/serviceCards/preview16 (1).jpg'
import img30 from '../imgs/serviceCards/preview16 (2).jpg'
import img31 from '../imgs/serviceCards/preview16.jpg'
import img32 from '../imgs/serviceCards/teamwork-3213924_1280.jpg'
import img33 from '../imgs/titleSectionShapes/Big Rect.svg'
import img34 from '../imgs/titleSectionShapes/Small Rect.svg'
import nextBtn from '../imgs/nextBtn.svg'
import previousBtn from '../imgs/previousBtn.svg'
import field1 from '../imgs/fieldsOfOperation/Path 2.svg'
import field2 from '../imgs/fieldsOfOperation/Path 3.svg'
import field3 from '../imgs/fieldsOfOperation/Path 4.svg'
import field4 from '../imgs/fieldsOfOperation/Path 5.svg'
import field5 from '../imgs/fieldsOfOperation/Shape 2.svg'
import field6 from '../imgs/fieldsOfOperation/Shape 3.svg'
import field7 from '../imgs/fieldsOfOperation/Shape 4.svg'
import field8 from '../imgs/fieldsOfOperation/Shape 5.svg'
import field9 from '../imgs/fieldsOfOperation/Shape 6.svg'
import field10 from '../imgs/fieldsOfOperation/Shape 7.svg'
import field11 from '../imgs/fieldsOfOperation/Shape 8.svg'
import field12 from '../imgs/fieldsOfOperation/Shape 9.svg'

const Home = () => {
  const { t, language } = useContext(api)

  const fields = [
    {
      img: field1,
      text: t("Real Estate")
    },
    {
      img: field2,
      text: t("Garments")
    },
    {
      img: field3,
      text: t("Industrial")
    },
    {
      img: field4,
      text: t("Tourism")
    },
    {
      img: field5,
      text: t("Health")
    },
    {
      img: field6,
      text: t("Agriculture")
    },
    {
      img: field7,
      text: t("Power")
    },
    {
      img: field8,
      text: t("Commercial")
    },
    {
      img: field9,
      text: t("Media")
    },
    {
      img: field10,
      text: t("Food & Bev.")
    },
    {
      img: field11,
      text: t("Communication")
    },
    {
      img: field12,
      text: t("Finance")
    }
  ];
  
  const clients = [
    img1, img2, img3, img4, img5, img6, img7, img8,
    img9, img10, img12, img13, img14, img15, img16,
    img17, img18, img19, img20, img21, img22, img23, img24
  ];

  const serviceCards = [
    {
      title: t('service1title'),
      description: t('service1description'),
      bckimg: img25
    },
    {
      title: t('service2title'),
      description: t('service2description'),
      bckimg: img26
    },
    {
      title: t('service3title'),
      description: t('service3description'),
      bckimg: img27
    },
    {
      title: t('service4title'),
      description: t('service4description'),
      bckimg: img28
    },
    {
      title: t('service5title'),
      description: t('service5description'),
      bckimg: img29
    },
    {
      title: t('service6title'),
      description: t('service6description'),
      bckimg: img30
    },
    {
      title: t('service7title'),
      description: t('service7description'),
      bckimg: img31
    },
    {
      title: t('service8title'),
      description: t('service8description'),
      bckimg: img32
    }
  ];

  const [serviceIndex, setServiceIndex] = useState(0)
  const [serviceCard, setServiceCard] = useState(serviceCards[serviceIndex])

  useEffect(() => {
    const updatedServiceCards = [
      {
        title: t('service1title'),
        description: t('service1description'),
        bckimg: img25
      },
      {
        title: t('service2title'),
        description: t('service2description'),
        bckimg: img26
      },
      {
        title: t('service3title'),
        description: t('service3description'),
        bckimg: img27
      },
      {
        title: t('service4title'),
        description: t('service4description'),
        bckimg: img28
      },
      {
        title: t('service5title'),
        description: t('service5description'),
        bckimg: img29
      },
      {
        title: t('service6title'),
        description: t('service6description'),
        bckimg: img30
      },
      {
        title: t('service7title'),
        description: t('service7description'),
        bckimg: img31
      },
      {
        title: t('service8title'),
        description: t('service8description'),
        bckimg: img32
      }
    ];
  
    setServiceCard(updatedServiceCards[serviceIndex])
  }, [serviceIndex, language])

  const handleNextServiceCard = () => {
    if (serviceIndex === serviceCards.length - 1) {
      setServiceIndex(0)
    } else {
      setServiceIndex(serviceIndex + 1)
    }
  }

  const handlePreviousServiceCard = () => {
    if (serviceIndex === 0) {
      setServiceIndex(serviceCards.length - 1)
    } else {
      setServiceIndex(serviceIndex - 1)
    }
  }

  return (
    <main>
      {/* Title Section and Landing */}
      <section className='titleSection' style={language === "ar" ? {direction: "rtl"} : {direction: "ltr"}}>
        <img loading="eager" className='titleBackground' src={titleBackground} alt=""></img>
        <div className='titleSectionContent'>
          <h1 className='titleMsg'>{t("titleScreenH1p1")}<span className="titleGreenUNG">{t("titleScreenH1p2")}</span><span className="titleGreenUNG">!</span></h1>
          <button className="learnMore" onClick={() => {document.getElementById('ServicesSection').scrollIntoView({ behavior: 'smooth' })}}>{t("learnMoreTitlesection")}</button>
          <div className={language === "ar" ? "rtltitleSectionShapes" : "ltrtitleSectionShapes"} id="shape1">
            <img loading="eager" src={img33} alt="shape1" />
          </div>
          <div className={language === "ar" ? "rtltitleSectionShapes" : "ltrtitleSectionShapes"} id="shape2">
            <img loading="eager" src={img34} alt="shape2" />
          </div>
        </div>
      </section>
      {/* Clients Section */}
      <section className="ClientsSection">
        <div className="clientsHeader">
          <div className="ClientHeaderLine"></div>
          <h2>{t("ourClients")}</h2>
          <div className="ClientHeaderLine"></div>
        </div>
        <Marquee className="clientsMarquee" autofill={true} direction={language === "ar" ? "right" : "left"}>
          {clients.map((client, index) => (
            <img loading="eager" key={index} src={client} alt="client" className="clientLogos" />
            ))}
        </Marquee>
      </section>
      <Divider/>
      {/* Services Section */}
      <section id="ServicesSection" className="ServicesSection">
        <h2>{t("servicesh2")}</h2>
        <div className="servicesContainer" key={language}>
          <img loading="eager" className="serviceControl" src={previousBtn} alt="Previous" onClick={() => {handlePreviousServiceCard()}} />
          <div className="serviceCard">
            <div className="serviceNumber">{serviceIndex + 1}</div>
            <img loading="eager" src={serviceCard.bckimg} alt="service" className="serviceBackground" />
            <div className="serviceCardContent" style={language === "ar" ? {direction: "rtl"} : {direction: "ltr"}}>
              <h3>{serviceCard.title}</h3>
              <p>{serviceCard.description}</p>
            </div>
            <div className="serviceSelectorsContainer">
              {
                serviceCards.map((service, index) => (
                  <button className="serviceSelector" style={serviceIndex === index ? {backgroundColor: "#45663B"} : {}} key={index} onClick={() => setServiceIndex(index)}></button>
                ))
              }
            </div>
          </div>
          <img loading="eager" className="serviceControl" src={nextBtn} alt="Next" onClick={() => {handleNextServiceCard()}} />
        </div>
      </section>
      {/* Fields in which we operate */}
      <section className="fieldsInWhichWeOperate">
          <div className="fieldHeadingContainer">
            <div className="fieldHeaderLine"></div>
            <h2 className="fieldsh2">{t("fieldsInWhichWeOperateh2")}</h2>
            <div className="fieldHeaderLine"></div>
          </div>
          <div className="fieldsGrid">
            {
              fields.map((field, index) => (
                <div key={index} className="fieldCard">
                  <img loading="eager" src={field.img} alt="field" />
                  <h3>{field.text}</h3>
                </div>
              ))
            }
          </div>
      </section>
      <Divider/>
      {/* FAQ Section */}
      <section className="FAQSection" style={language === "ar" ? {direction: "rtl"} : {direction: "ltr"}}>
        <div className={language === "ar" ? "pinnedRight whyUs" : "pinnedLeft whyUs"}>
          <h3>{t("whyUS")}</h3>
          <p>{t("whyUSp")}</p>
        </div>
        <div className={language === "ar" ? "pinnedLeft howOperate" : "pinnedRight howOperate"}>
          <h3>{t("howOperate")}</h3>
          <p>{t("howOperatep")}</p>
        </div>
        
      </section>
    </main>
  )
}

export default Home